module.exports = __webpack_public_path__ + "media/images/chartmogul-a37309711f938bc094633e8b9df0bf25.svg";